import { Modal } from '@trackman/web-shared-components';
import { auth } from 'stores/AuthorizationStore';
import { observer } from 'mobx-react-lite';
import { t } from 'utilities/TranslationUtils';

type Props = {
  logoutUrl: string;
};

const LoggedOutInfoModal = observer(({ logoutUrl }: Props) => {
  return (
    <Modal
      title={t('LoggedOut')}
      open={auth.isLoggedOutModalOn}
      onClose={() => auth.setIsLoggedOutModalOn(false)}
      confirmBtn={{ label: t('LoggedOut.redirect'), onClick: () => window.location.assign(logoutUrl) }}
      cancelBtn={{ label: t('LoggedOut.stay'), onClick: () => auth.setIsLoggedOutModalOn(false) }}
      style={{ zIndex: 2001 }}
    >
      <div>
        <p>{t('LoggedOut.message.loggedOut')}</p>
        <p>{t('LoggedOut.message.saveProgress')}</p>
        <p>{t('LoggedOut.message.pleaseLogin')}</p>
      </div>
    </Modal>
  );
});

export default LoggedOutInfoModal;
